import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import ApplicationShell from '@anwb/poncho/components/application-shell';
import { Fonts, LegacyGlobalTypography } from '@anwb/poncho/design-tokens/theme';
import { ANWBBrandRefreshTheme } from '@anwb/poncho/design-tokens/theme/themes/anwb-brand-refresh-theme';
import ApplicationSizeProvider from '@anwb/poncho/providers/providers-application';
import { RequestFlow } from 'components/RequestFlow';
import { ThemeProvider } from 'styled-components';

import store from '../store/store';

export const Application = () => (
	<ThemeProvider theme={ANWBBrandRefreshTheme}>
		<Fonts />
		<LegacyGlobalTypography />
		<ApplicationSizeProvider>
			<ApplicationShell>
				<Provider store={store}>
					<BrowserRouter>
						<RequestFlow />
					</BrowserRouter>
				</Provider>
			</ApplicationShell>
		</ApplicationSizeProvider>
	</ThemeProvider>
);
